<div *ngIf="!isClosed"
    class="plan-alert-container display-flex plan-alert-shadow text-center pad-8 font-14 accent-box text-primary">
    <div class="flex-centered-container flex-grow">
        <img src="assets/trending.svg" alt="Plan Alert" class="margin-right transform-big">
        <div class="margin-right" [innerHTML]="this.newFeatureAlert.text">
        </div>
        <a class="margin-right text-accent decoration-underline cursor-pointer" (click)="openLink()"
            [innerHTML]="this.newFeatureAlert.linkText">
        </a>
    </div>
    <div>
        <mat-icon class="cursor-pointer margin-right" (click)="close()">
            close
        </mat-icon>
    </div>
</div>